import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'

import 'bootstrap/dist/css/bootstrap.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import '@fortawesome/fontawesome-svg-core/styles.css'
import 'react-toastify/dist/ReactToastify.css'
import './styles/app.scss'

import Root from './router'
import store from './store'

const container = document.getElementById('app')

if (!container) {
    throw new Error('Missing #app root element in index.html')
}

const root = createRoot(container)

root.render(
    <Provider store={store}>
        <Root />
    </Provider>,
)
